import componentLocator from '../../../assets/javascripts/component_locator'

export default class Register extends BaseComponent {
    initialize() {
        this.bindTermsCheckbox();
    }

    bindTermsCheckbox() {
        this.find('input[name="accepted-terms"]').change(() => this.updateSubmitButton());
        this.find('select[name="address-country"]').change(() => this.updateSubmitButton());
    }

    updateSubmitButton() {
        let acceptsTerms = this.find('input[name="accepted-terms"]');
        let country = this.find('select[name="address-country"] option:selected').val();
        if (country != 'Select Country' && acceptsTerms.prop('checked')) {
            this.find('.submit-registration').removeAttr('disabled');
        } else {
            this.find('.submit-registration').attr('disabled', 'disabled');
        }
    }

    submit() {
        this.find('[name="email"]')[0].setCustomValidity('');
        if (!this.find('input,select').toArray().every(e => e.reportValidity())) {
            return false;
        }
        $.post('/register', this.find('form').serialize())
            .done(data => window.location.href = data.redirect)
            .fail(error => {
                if (error.status == 409) {
                    this.flashError(
                        this.find('[name="email"]')[0],
                        'A contact already exists with this email address.'
                    )
                }
            })
    }

    flashError(element, message) {
        element.setCustomValidity(message);
        element.reportValidity();
    }
}